import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { useAppTakeoverPdp } from 'components/app-takeover/use-app-takeover';
import { t } from 'state/intl/translations';
import { isCombo } from 'state/unified-menu/utils';

import { useProductWizardContext } from '../../product-wizard';
import { ProductWizardStep } from '../../product-wizard/types';
import { useProductWizardFlow } from '../../product-wizard/use-product-wizard-flow';
import { isCustomization } from '../utils';

export const GoNextCta = () => {
  const { selectedProduct, pickerSelections, slotsSelections } = useProductWizardContext();
  const { goToNextStep, nextFlowStep, currentFlowStep, id } = useProductWizardFlow();
  const { isTakeoverActive } = useAppTakeoverPdp(id);

  const getButtonLabel = () => {
    let dictionaryKey = null;

    switch (nextFlowStep?.step) {
      case ProductWizardStep.PickerCustomizationSides: {
        dictionaryKey = 'nextSelectYourSide';
        break;
      }
      case ProductWizardStep.PickerCustomizationDrinks: {
        dictionaryKey = 'nextSelectYourDrink';
        break;
      }
      case ProductWizardStep.PickerReview: {
        dictionaryKey = isCombo(selectedProduct) ? 'nextReviewYourMeal' : 'nextReviewYourSelection';
        break;
      }
      default: {
        dictionaryKey = 'nextCustomize';
      }
    }

    return t(dictionaryKey);
  };

  const isDisabled = () => {
    if (currentFlowStep.step === ProductWizardStep.ProductHome) {
      return !Object.keys(pickerSelections).length;
    }
    if (currentFlowStep.step === ProductWizardStep.PickerSelection) {
      return !Object.keys(pickerSelections).includes(currentFlowStep.pickerAspectKey ?? '');
    }
    if (isCustomization(currentFlowStep.step)) {
      return !!currentFlowStep.slotKey && !slotsSelections[currentFlowStep.slotKey];
    }
    return false;
  };

  return (
    <ActionButton
      testID="product-customization-action-button"
      flex={1}
      onPress={goToNextStep}
      disabled={isDisabled()}
      variant={
        isTakeoverActive ? ActionButtonVariants.PRIMARY_TAKEOVER : ActionButtonVariants.PRIMARY
      }
    >
      {getButtonLabel()}
    </ActionButton>
  );
};
